

const Mission = () => {
  return (
    <div>Mission</div>
  )
}

export default Mission